/**
 * Blocklist of known disposable/throwaway email domains.
 * Used to prevent bot signups with temporary inboxes.
 */
const DISPOSABLE_DOMAINS = new Set([
  // High-volume disposable providers
  'mailinator.com',
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.de',
  'grr.la',
  'guerrilla.ml',
  'tempmail.com',
  'temp-mail.org',
  'temp-mail.io',
  'throwaway.email',
  'throwaway.com',
  'yopmail.com',
  'yopmail.fr',
  'sharklasers.com',
  'guerrillamailblock.com',
  'pokemail.net',
  'spam4.me',
  'dispostable.com',
  'maildrop.cc',
  'mailnesia.com',
  'mailnull.com',
  'trashmail.com',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashymail.com',
  'tempail.com',
  'tempr.email',
  'tempmailaddress.com',
  'tmpmail.org',
  'tmpmail.net',
  'mohmal.com',
  'burnermail.io',
  'discard.email',
  'discardmail.com',
  'discardmail.de',
  'fakeinbox.com',
  'fakemail.net',
  'getairmail.com',
  'getnada.com',
  'harakirimail.com',
  'mailcatch.com',
  'mailexpire.com',
  'mailforspam.com',
  'meltmail.com',
  'mintemail.com',
  'mytemp.email',
  'mytrashmail.com',
  'nomail.xl.cx',
  'nospam.ze.tc',
  'owlpic.com',
  'receiveee.com',
  'spambox.us',
  'spamfree24.org',
  'spaml.com',
  'tempomail.fr',
  'tempinbox.com',
  'temporaryemail.net',
  'temporarymail.org',
  'thankdog.com',
  'tmail.ws',
  'trash-mail.at',
  'trashmail.ws',
  'wegwerfmail.de',
  'wegwerfmail.net',
  'wh4f.org',
  'mailsac.com',
  'inboxkitten.com',
  'emailondeck.com',
  'crazymailing.com',
  '10minutemail.com',
  '10minutemail.net',
  '20minutemail.com',
  'guerrillamail.info',
  'disposableemailaddresses.emailmiser.com',
  'mailtemp.info',
  'tmail.com',
  'tempmailer.com',
  'tempmailer.de',
  'throwam.com',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'jetable.org',
  'mailzilla.com',
  'kasmail.com',
  'emkei.cz',
  'anonymbox.com',
  'courrieltemporaire.com',
  'incognitomail.org',
  'mailme.lv',
  'mailmoat.com',
  'mysteriousmail.com',
  'nobulk.com',
  'oneoffemail.com',
  'spamhereplease.com',
  'tempemail.net',
  'tempinbox.co.uk',
  'trash2009.com',
  'yolanda.dev',
])

/**
 * Check if an email address uses a known disposable domain.
 * @param {string} email
 * @returns {{ allowed: boolean, reason?: string }}
 */
export function checkDisposableEmail(email) {
  if (!email) return { allowed: true }
  const domain = email.split('@')[1]?.toLowerCase()
  if (!domain) return { allowed: true }
  if (DISPOSABLE_DOMAINS.has(domain)) {
    return { allowed: false, reason: 'Please use a permanent email address. Disposable emails are not allowed.' }
  }
  return { allowed: true }
}
